import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, BellIcon, CheckCircle2Icon, MessageCircleIcon } from 'lucide-react';
import { WhatsAppButton } from './WhatsAppButton';
import { HeroMockup } from './HeroMockup';
import { QUOTE_MESSAGE } from '../utils/contact';
const floatingCards = [{
  id: 'lead',
  icon: BellIcon,
  title: 'Nuevo lead recibido',
  meta: 'hace 2 min'
}, {
  id: 'form',
  icon: CheckCircle2Icon,
  title: 'Solicitud enviada',
  meta: 'formulario web'
}, {
  id: 'wa',
  icon: MessageCircleIcon,
  title: 'Cliente conectado por WhatsApp',
  meta: 'en línea'
}];
export function Hero() {
  return <section id="inicio" className="relative overflow-hidden pt-28 lg:pt-36" data-id="element-129" data-mp="sa9rtct2xrw4">
      <div aria-hidden="true" className="pointer-events-none absolute -left-32 top-10 h-72 w-72 rounded-full bg-neon/10 blur-[120px]" data-id="element-130" data-mp="ncq31iyr9wpx" />
      <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-neon/40 to-transparent" data-id="element-131" data-mp="3czfms3kkof85" />

      <div className="mx-auto grid max-w-page items-center gap-14 px-5 pb-20 lg:grid-cols-[1.05fr_0.95fr] lg:gap-10 lg:px-8 lg:pb-28" data-id="element-132" data-mp="3j9265qny7uwl">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-133" data-mp="39acxmohxzmt0">
          <span className="inline-flex items-center gap-2 rounded-full border border-neon/30 bg-neon/5 px-4 py-1.5 text-xs text-neon" data-id="element-134" data-mp="3ebisosz2rm5p">
            Diseño web estratégico · USA & Latinoamérica
          </span>

          <h1 className="mt-6 text-4xl font-semibold leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl" data-id="element-135" data-mp="35akmq552t4kh">
            Transformamos tu negocio en una{' '}
            <span className="relative whitespace-nowrap text-neon" data-id="element-136" data-mp="2vjg5eyrxh7mh">
              presencia digital
              <span aria-hidden="true" className="absolute -bottom-1 left-0 h-px w-full bg-neon/60" data-id="element-137" data-mp="2hjox9eo3elge" />
            </span>{' '}
            que vende
          </h1>

          <p className="mt-6 max-w-xl text-base leading-relaxed text-mist-muted sm:text-lg" data-id="element-138" data-mp="s3cmudv0pps5">
            En YenniDigital creamos páginas web de alta conversión, estrategias digitales y
            sistemas conectados a WhatsApp, formularios, redes sociales y tiendas online para
            negocios en USA y Latinoamérica.
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-139" data-mp="1b0ni7ndj3z2b">
            <WhatsAppButton message={QUOTE_MESSAGE} size="lg" data-id="element-140" data-mp="1ayjep6jjl22k">
              Solicitar Cotización por WhatsApp
            </WhatsAppButton>
            <a href="#portafolio" className="inline-flex items-center justify-center gap-2 rounded-full border border-white/25 px-7 py-4 text-base font-medium text-white transition-[background-color,border-color,transform] duration-200 ease-out hover:border-neon hover:bg-neon/10 hover:text-neon active:translate-y-px" data-id="element-141" data-mp="111y9ak3m1oy7">
              Ver Portafolio
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-142" data-mp="1xa41h7xz88gg" />
            </a>
          </div>

          <ul className="mt-10 flex flex-wrap gap-x-6 gap-y-2 text-xs text-mist-dim" data-id="element-143" data-mp="21a4t5ua36g5g">
            <li data-id="element-144" data-mp="269he29hedd5e">Mobile-first</li>
            <li aria-hidden="true" className="text-neon/50" data-id="element-145" data-mp="2697o2lwcr5zp">
              •
            </li>
            <li data-id="element-146" data-mp="2b1hk8jo292af">Copy persuasivo</li>
            <li aria-hidden="true" className="text-neon/50" data-id="element-147" data-mp="2b2sk48edxpw9">
              •
            </li>
            <li data-id="element-148" data-mp="2g1wwf7wlw3qt">Conectado a WhatsApp</li>
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative" data-id="element-149" data-mp="2kxc6rpvenhih">
          <HeroMockup videoSrc="https://cdn.magicpatterns.com/uploads/tCnYtZmS5BshpPYqg5z7A4/Mi video (1).mp4" mobileImageSrc="https://cdn.magicpatterns.com/uploads/qJhzbY1GYkesgqTN6MTQfq/imagenweb1.webp" data-id="element-150" data-mp="2tx7mm7zwo0ou" />

          <div className="mt-6 grid gap-3 sm:grid-cols-3 lg:absolute lg:-left-6 lg:bottom-2 lg:mt-0 lg:w-64 lg:grid-cols-1" data-id="element-151" data-mp="4aclrbd6jn6w">
            {floatingCards.map((card, i) => <motion.div key={card.id} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.25,
            delay: 0.2 + i * 0.06,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex items-center gap-3 rounded-xl border border-neon/25 bg-ink-900/90 px-3 py-2.5 backdrop-blur" data-id="element-152" data-mp="e9a6e37hiwkm" data-mpi={i}>
                <span className="grid h-8 w-8 shrink-0 place-items-center rounded-lg bg-neon/10 text-neon" data-id="element-153" data-mp="3rheqpvzogdzi">
                  <card.icon className="h-4 w-4" aria-hidden="true" data-id="element-154" data-mp="3mnail9eodzwu" />
                </span>
                <span className="min-w-0" data-id="element-155" data-mp="2yxoh2fatz8lo">
                  <span className="block truncate text-xs font-medium text-white" data-id="element-156" data-mp="2u17uvqn6z4b8">
                    {card.title}
                  </span>
                  <span className="block text-[10px] text-mist-dim" data-id="element-157" data-mp="19h2m46fhcxz4">{card.meta}</span>
                </span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}